import React from 'react';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { trackMainMenuNavigateClick } from '../tracking/discovery.tracking';

const NavLink = ({ title, url }) => {
  const handleClick = () => {
    trackMainMenuNavigateClick(title);
  };

  return (
    <LinkContainer to={url} exact>
      <Nav.Link onClick={handleClick}>{title}</Nav.Link>
    </LinkContainer>
  );
};

export default NavLink;
